import * as React from 'react';
import Helmet from 'react-helmet';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { useIntl } from 'react-intl';
import Select from 'pages/Report/components/Select';
import SelectItem from 'pages/Report/components/Select/components/SelectItem';
import MonthlyReportsTable from './components/MonthlyReportsTable';

const REPORT_PRIMARY_LIGHT = '#aad8d6';
const REPORT_PRIMARY_MAIN = '#008b87';

const useStyles = makeStyles((theme) => ({
  pageContainer: {
    display: 'flex',
    paddingTop: 24,
    flexDirection: 'column',
    overflow: 'visible',
    minHeight: 'calc(100vh - 80px)',
    [theme.breakpoints.down('md')]: {
      paddingLeft: 8,
      paddingRight: 8
    }
  },
  subPageSelect: {
    width: 'fit-content',
    marginBottom: theme.spacing(3)
  },
  outlinedPrimary: {
    borderColor: REPORT_PRIMARY_LIGHT,
    borderRadius: 5,
    borderWidth: 1,
    borderStyle: 'solid',

    '& .MuiButton-endIcon': {
      color: REPORT_PRIMARY_LIGHT
    },

    '&:hover': {
      borderColor: REPORT_PRIMARY_LIGHT,

      '& .MuiButton-endIcon': {
        color: REPORT_PRIMARY_MAIN
      }
    }
  },
  iconSizeMedium: {
    '& > *:first-child': {
      fontSize: 22
    }
  },
  content: {
    '& > .placeholder': {
      minHeight: 'calc(100vh - 116px)'
    },
    minWidth: 300,
    overflow: 'visible'
  }
}));

const ADMIN_SUB_PAGES = [
  {
    intlKey: 'admin.monthlyReports',
    component: <MonthlyReportsTable />
  }
];

export const AdminPage: React.FC = () => {
  const classes = useStyles();
  const intl = useIntl();
  const [selectedSection, setSelectedSection] = React.useState(0);
  const selectedLabel = intl.formatMessage({ id: ADMIN_SUB_PAGES[selectedSection].intlKey });

  return (
    <div className={classes.pageContainer}>
      <Helmet title={intl.formatMessage({ id: 'admin.title' })} />
      <div className={classes.subPageSelect}>
        <Select
          closeOnSelect
          renderValue={() => selectedLabel}
          buttonProps={{
            classes: {
              outlinedPrimary: classes.outlinedPrimary,
              iconSizeMedium: classes.iconSizeMedium
            }
          }}
          menuProps={{
            MenuListProps: { disablePadding: true }
          }}
        >
          {ADMIN_SUB_PAGES.map((section, index) => (
            <SelectItem key={section.intlKey} onClick={() => setSelectedSection(index)}>
              <Typography>{intl.formatMessage({ id: section.intlKey })}</Typography>
            </SelectItem>
          ))}
        </Select>
      </div>
      <div className={classes.content}>{ADMIN_SUB_PAGES[selectedSection]?.component ?? null}</div>
    </div>
  );
};

export default AdminPage;
